<template>
  <div v-if="offerId" class="flex items-center md:order-last">
    <div
      class="bg-static-info-mid border-static-default-low rounded-lg flex items-center border p-8"
    >
      <IconSim />
    </div>
    <RevLink
      class="ml-12 text-left"
      @click="openModal(MODAL_NAMES.MOBILE_PLAN_ASSISTANCE, $event)"
    >
      {{
        i18n(translations.mobilePlanAssistance, { partnerLabel: partner.label })
      }}
    </RevLink>

    <MobilePlanAssistanceDrawer
      :name="MODAL_NAMES.MOBILE_PLAN_ASSISTANCE"
      :offer-id
      :partner
    />
  </div>
</template>

<script setup lang="ts">
import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'
import { IconSim } from '@ds/icons/IconSim'

import MobilePlanAssistanceDrawer from '../MobilePlanAssistanceDrawer/MobilePlanAssistanceDrawer.vue'

import { MODAL_NAMES } from './MobilePlanReassuranceItems.constants'
import translations from './MobilePlanReassuranceItems.translations'

const i18n = useI18n()

defineProps<{
  offerId?: string
  partner: MobilePlanOffer['partner']
}>()
</script>
